<template>
  <div class="d-contents">
    <ProjectAlertBlock />
    <div class="project-summary">
      <div class="project-summary_left spacey-12">
        <div class="project-summary__header">
          <div class="project-summary__title">
            {{ $t('Project info') }}
          </div>
          <Button
            type="func"
            size="small"
            left-icon="download"
            :loading="downloading"
            @click="downloadAsExcel"
          >
            {{ $t('Export to Excel') }}
          </Button>
        </div>
        <Info
          :project-info="projectInfo"
          @show-more-description="showMoreDescription"
          @upload-image="updateProjectImage($event)"
          @delete-image="deleteProjectImage"
        />
        <SummaryTable class="project-summary__table" />
      </div>
      <div class="project-summary_right">
        <ProjectTenders />
      </div>
    </div>
  </div>
</template>
<script>
  import SummaryTable from '@/containers/project/SummaryTable';
  import { mapActions, mapState } from 'vuex';
  import Info from '@/components/project/summary/Info';
  import ProjectTenders from '@/containers/project/tenders/ProjectTenders';
  import DescriptionModal from '@/components/project/summary/DescriptionModal';
  import Button from '@/components/ui/Button';
  import DownloadIcon from '@/assets/icons/download.svg';
  import downloadByLink from '@/utils/download-by-link';
  import ProjectAlertBlock from '@/containers/project/ProjectAlertBlock';

  export default {
    components: {
      ProjectTenders,
      Info,
      SummaryTable,
      Button,
      ProjectAlertBlock,
    },
    data() {
      return {
        downloadIcon: DownloadIcon,
        downloading: false,
      };
    },
    computed: {
      ...mapState('project', ['projectInfo']),
    },
    methods: {
      ...mapActions('project', ['loadProjectInfo', 'updateProjectImage', 'deleteProjectImage']),
      ...mapActions({
        openModal: 'modal/openModal',
      }),
      showMoreDescription() {
        this.openModal({
          component: DescriptionModal,
          context: {
            projectName: this.projectInfo.name,
            projectDescription: this.projectInfo.description,
          },
        });
      },
      async loadProjectInfoHandler() {
        const projectId = this.$route.params.id;
        await this.loadProjectInfo({ id: projectId });
      },
      async downloadAsExcel() {
        this.downloading = true;
        await downloadByLink({
          link: `/projects/${this.$route.params.id}/xlsx/`,
          fileName: `${this.projectInfo.name}.xlsx`,
        });
        this.downloading = false;
      },
    },
    async mounted() {
      await this.loadProjectInfoHandler();
    },
    watch: {
      '$route.params.id': async function () {
        await this.loadProjectInfoHandler();
      },
    },
  };
</script>
